<template>
  <div class="horarios-table d-flex flex-row flex">
    <v-tabs
      v-model="indexDataSelected"
      show-arrows
      @change="$emit('update-data', formatedDate(datas[indexDataSelected]))"
    >
      <v-tabs-slider color="teal lighten-3"></v-tabs-slider>
      <v-tab v-for="(data, index) in datas" :key="index">
        <div class="d-flex flex-column data">
          <div class="mb-1">
            {{ getDayName(data) }}
          </div>
          <div>
            {{ data.getDate() + '/' + getMonthName(data) }}
          </div>
        </div>
      </v-tab>
    </v-tabs>
  </div>
</template>

<script>
import { format } from 'date-fns'
export default {
  name: 'HorarioSlider',
  props: {
    searchOnInit: {
      required: false,
      type: Boolean,
      default: true
    },
    dtExame: {
      required: false
    }
  },
  data() {
    return {
      datas: [],
      indexDataSelected: 0
    }
  },
  methods: {
    formatedDate(date) {
      return format(date, 'yyyy-MM-dd')
    },
    gerarDatas() {
      const currentDate = new Date()
      const datas = []
      for (let i = 0; i < 15; i++) {
        const newDate = new Date()
        newDate.setDate(currentDate.getDate() + i)
        datas.push(new Date(newDate))
      }
      this.datas = datas.filter(data => !['sábado', 'domingo'].includes(this.getDayName(data)))
    },
    getDayName(date) {
      return date.toLocaleDateString('pt-br', { weekday: 'long' })
    },
    getMonthName(date) {
      return date.toLocaleDateString('pt-br', { month: 'long' })
    }
  },
  mounted() {
    this.gerarDatas()
    this.$emit('update-data', this.formatedDate(this.datas[this.indexDataSelected], 'yyyy-MM-dd'))
  }
}
</script>

<style scoped>
.data {
  font-size: 0.8rem;
}
</style>
